"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInit = exports.isLegacy = exports.isLoginAs = exports.hello = exports.refreshToken = exports.logout = exports.getAuthorizationHeader = exports.redirectToLogin = exports.isAuthenticated = exports.initCesAuth = exports.startGetTokenLoop = exports.stopGetTokenLoop = exports.authAxiosInstance = exports.cesAuthOptions = void 0;
var axios_1 = __importDefault(require("axios"));
var config_1 = __importStar(require("./utils/config"));
var cookie_1 = require("./utils/cookie");
var inactivityTimeout_1 = require("./utils/inactivityTimeout");
var jwt_1 = require("./utils/jwt");
var localStorage_1 = require("./utils/localStorage");
var retry_1 = __importDefault(require("./utils/retry"));
var updateActiveTimestamp_1 = __importDefault(require("./utils/updateActiveTimestamp"));
var wait_1 = __importStar(require("./utils/wait"));
var EVENT_CES_ON_INIT = "cesAuthOnInit";
var EVENT_CES_ON_TOKEN = "cesAuthOnToken";
var EVENT_CES_ON_SESSION_EXPIRED = "cesAuthOnSessionExpired";
var EVENT_CES_ON_INACTIVITY_WARNING = "cesAuthOnInactivityWarning";
var isExpired = false;
var isRetrievingToken = false;
var isGetTokenLoopStarted = false;
var source;
exports.cesAuthOptions = {
    authBaseURL: "https://id-api.cheetahces.com",
    sessionExpiredPageUrl: "https://id.cheetahces.com/session-expired",
    isFetchTokenInBackground: true,
    isHandleInactivity: true,
    isRedirectOnSessionExpired: true,
    isLoginAs: false,
    isLegacy: false,
    isInit: false
};
var waitForTokenEventPromise = function () {
    return new Promise(function (resolve, reject) {
        var onToken = function (_a) {
            var detail = _a.detail;
            window.removeEventListener(EVENT_CES_ON_TOKEN, onToken);
            if (!(detail === null || detail === void 0 ? void 0 : detail.access_token)) {
                return reject();
            }
            resolve(detail);
        };
        window.addEventListener(EVENT_CES_ON_TOKEN, onToken);
    });
};
var dispatchTokenEvent = function (token) {
    window.dispatchEvent(new CustomEvent(EVENT_CES_ON_TOKEN, {
        detail: token
    }));
};
var dispatchInitEvent = function () {
    exports.cesAuthOptions.isInit = true;
    window.dispatchEvent(new CustomEvent(EVENT_CES_ON_INIT));
};
var dispatchSessionExpiredEvent = function () {
    isExpired = true;
    window.dispatchEvent(new CustomEvent(EVENT_CES_ON_SESSION_EXPIRED));
};
var retrieveTokenApi = function () { return __awaiter(void 0, void 0, void 0, function () {
    var CancelToken, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                CancelToken = axios_1.default.CancelToken;
                if (source) {
                    source.cancel();
                }
                source = CancelToken.source();
                return [4 /*yield*/, retry_1.default(function () {
                        return axios_1.default.post("/user/token?is_login_as=" + !!exports.cesAuthOptions.isLoginAs, null, {
                            cancelToken: source.token,
                            baseURL: exports.cesAuthOptions.authBaseURL,
                            headers: {
                                Accept: "*/*",
                                "Content-Type": "application/json"
                            },
                            withCredentials: true
                        });
                    }, 3)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
var retrieveToken = function () { return __awaiter(void 0, void 0, void 0, function () {
    var data, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (isRetrievingToken) {
                    return [2 /*return*/, waitForTokenEventPromise()];
                }
                isRetrievingToken = true;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, retrieveTokenApi()];
            case 2:
                data = _a.sent();
                dispatchTokenEvent(data);
                isRetrievingToken = false;
                return [2 /*return*/, data];
            case 3:
                err_1 = _a.sent();
                dispatchTokenEvent(undefined);
                isRetrievingToken = false;
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };
var setBusinessUnitCookie = function (_a) {
    var _b;
    var access_token = _a.access_token;
    var host = (_b = exports.cesAuthOptions.authBaseURL) === null || _b === void 0 ? void 0 : _b.split(".").splice(-2).join(".");
    var business_unit_id = jwt_1.getJWTPublicClaim(access_token).business_unit_id;
    if (!host) {
        return;
    }
    cookie_1.setCookie("business_unit_id", business_unit_id, host, "/");
};
var setLocalToken = function (_a) {
    var access_token = _a.access_token, expires_in = _a.expires_in, token_type = _a.token_type;
    var expirationDate = new Date();
    expirationDate.setSeconds(expirationDate.getSeconds() + (expires_in - 10));
    var token = {
        expiresIn: expires_in,
        expirationDate: expirationDate,
        accessToken: access_token,
        tokenType: token_type
    };
    localStorage_1.setLocalStorage("tokens", token);
};
var getLocalToken = function () {
    return (localStorage_1.getLocalStorage("tokens") || {});
};
var isTokenExpired = function () {
    var expirationDate = getLocalToken().expirationDate;
    var dateNow = new Date();
    var dateExpired = new Date(expirationDate);
    var timeDiff = (dateExpired.getTime() - dateNow.getTime()) / 1000;
    return timeDiff < 0;
};
var isTokenValid = function () {
    var accessToken = getLocalToken().accessToken;
    return !!accessToken && !isTokenExpired();
};
var getToken = function (force, isDisableRedirect) {
    if (force === void 0) { force = false; }
    if (isDisableRedirect === void 0) { isDisableRedirect = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var tokens;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!isTokenValid() || force)) return [3 /*break*/, 2];
                    return [4 /*yield*/, retrieveToken()];
                case 1:
                    tokens = _a.sent();
                    if (!(tokens === null || tokens === void 0 ? void 0 : tokens.access_token)) {
                        dispatchSessionExpiredEvent();
                        if (isDisableRedirect) {
                            return [2 /*return*/];
                        }
                        if (exports.cesAuthOptions.isRedirectOnSessionExpired) {
                            exports.redirectToLogin();
                            return [2 /*return*/];
                        }
                        return [2 /*return*/];
                    }
                    setLocalToken(tokens);
                    setBusinessUnitCookie(tokens);
                    _a.label = 2;
                case 2: return [2 /*return*/, getLocalToken()];
            }
        });
    });
};
var onSuccess = function (res) { return Promise.resolve(res); };
var onError = function (err) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!err) {
                    return [2 /*return*/, Promise.reject()];
                }
                if (((_b = err.response) === null || _b === void 0 ? void 0 : _b.status) !== 401) {
                    return [2 /*return*/, Promise.reject(err)];
                }
                if (err.config.retry) {
                    if (exports.cesAuthOptions.isRedirectOnSessionExpired) {
                        exports.redirectToLogin();
                        return [2 /*return*/];
                    }
                    return [2 /*return*/];
                }
                err.config.retry = true;
                _a = err.config.headers;
                return [4 /*yield*/, exports.getAuthorizationHeader(true)];
            case 1:
                _a.authorization = _d.sent();
                if ((_c = err.config) === null || _c === void 0 ? void 0 : _c.data) {
                    return [2 /*return*/, axios_1.default(__assign(__assign({}, err.config), { data: JSON.parse(err.config.data) }))];
                }
                return [2 /*return*/, axios_1.default(err.config)];
        }
    });
}); };
var onSessionExpired = function () {
    if (exports.cesAuthOptions.isRedirectOnSessionExpired) {
        exports.redirectToLogin();
        return;
    }
    dispatchSessionExpiredEvent();
};
var getTokenRecursively = function (force) {
    if (force === void 0) { force = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        var expiresIn;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getToken(force)];
                case 1:
                    _a.sent();
                    expiresIn = getLocalToken().expiresIn;
                    if (!!expiresIn) return [3 /*break*/, 3];
                    return [4 /*yield*/, exports.stopGetTokenLoop()];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
                case 3: return [4 /*yield*/, wait_1.default((expiresIn - 10) * 1000)];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, getTokenRecursively()];
                case 5:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
var dispatchInactivityWarningEvent = function () {
    window.dispatchEvent(new CustomEvent(EVENT_CES_ON_INACTIVITY_WARNING, {
        detail: {
            end: function () {
                inactivityTimeout_1.stopInactivityTimeout();
                onSessionExpired();
            },
            stay: function () {
                updateActiveTimestamp_1.default();
                exports.startGetTokenLoop();
            }
        }
    }));
};
var stopGetTokenLoop = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!isGetTokenLoopStarted || isExpired) {
            return [2 /*return*/];
        }
        isGetTokenLoopStarted = false;
        clearTimeout(wait_1.timeout);
        return [2 /*return*/];
    });
}); };
exports.stopGetTokenLoop = stopGetTokenLoop;
var startGetTokenLoop = function (force) {
    if (force === void 0) { force = true; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!exports.cesAuthOptions.isFetchTokenInBackground) {
                        exports.cesAuthOptions.isFetchTokenInBackground = true;
                    }
                    if (isGetTokenLoopStarted || isExpired) {
                        return [2 /*return*/];
                    }
                    isGetTokenLoopStarted = true;
                    if (!exports.cesAuthOptions.isHandleInactivity) return [3 /*break*/, 2];
                    return [4 /*yield*/, config_1.initConfig()];
                case 1:
                    _a.sent();
                    inactivityTimeout_1.startInactivityTimeout(function () {
                        exports.stopGetTokenLoop();
                        dispatchInactivityWarningEvent();
                    }, onSessionExpired);
                    _a.label = 2;
                case 2: return [4 /*yield*/, getTokenRecursively(force)];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
exports.startGetTokenLoop = startGetTokenLoop;
var handleVisibilityChange = function () {
    if (!exports.cesAuthOptions.isFetchTokenInBackground) {
        return;
    }
    if (document.hidden) {
        exports.stopGetTokenLoop();
        if (exports.cesAuthOptions.isHandleInactivity) {
            inactivityTimeout_1.stopInactivityTimeout();
        }
        return;
    }
    if (exports.cesAuthOptions.isHandleInactivity) {
        var activeTimestamp = cookie_1.getCookie("activeTimestamp");
        var currentTime = new Date().getTime();
        var lastActiveTime = new Date(activeTimestamp).getTime();
        var inactiveDuration = currentTime - lastActiveTime;
        var _a = config_1.default.config, sessionInactivityExpiryTime = _a.sessionInactivityExpiryTime, sessionInactivityWarningTime = _a.sessionInactivityWarningTime;
        if (sessionInactivityExpiryTime - inactiveDuration < 0) {
            onSessionExpired();
            return;
        }
        if (sessionInactivityWarningTime - inactiveDuration < 0) {
            dispatchInactivityWarningEvent();
            return;
        }
    }
    exports.startGetTokenLoop(false);
};
var initCesAuth = function (defaultCesAuthOptions) {
    if (defaultCesAuthOptions === void 0) { defaultCesAuthOptions = exports.cesAuthOptions; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            localStorage_1.removeLocalStorage("tokens");
            exports.cesAuthOptions = __assign(__assign({}, exports.cesAuthOptions), defaultCesAuthOptions);
            if (exports.cesAuthOptions.isLegacy) {
                dispatchInitEvent();
                return [2 /*return*/];
            }
            exports.authAxiosInstance = axios_1.default.create({
                headers: {
                    Accept: "*/*",
                    "Content-Type": "application/json"
                }
            });
            exports.authAxiosInstance.interceptors.request.use(function (config) { return __awaiter(void 0, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = config.headers;
                            return [4 /*yield*/, exports.getAuthorizationHeader()];
                        case 1:
                            _a.authorization = _b.sent();
                            return [2 /*return*/, config];
                    }
                });
            }); });
            exports.authAxiosInstance.interceptors.response.use(onSuccess, onError);
            cesAuth.authAxiosInstance = exports.authAxiosInstance;
            if (exports.cesAuthOptions.isFetchTokenInBackground) {
                exports.startGetTokenLoop();
            }
            document.addEventListener("visibilitychange", handleVisibilityChange);
            dispatchInitEvent();
            return [2 /*return*/];
        });
    });
};
exports.initCesAuth = initCesAuth;
var isAuthenticated = function (force) {
    if (force === void 0) { force = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getToken(force, true)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, isTokenValid()];
                case 2:
                    err_2 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
};
exports.isAuthenticated = isAuthenticated;
var redirectToLogin = function () {
    if (!exports.cesAuthOptions.sessionExpiredPageUrl) {
        return;
    }
    window.location.href = exports.cesAuthOptions.sessionExpiredPageUrl;
    document.getElementsByTagName("body")[0].style.display = "none";
};
exports.redirectToLogin = redirectToLogin;
var getAuthorizationHeader = function (force) {
    if (force === void 0) { force = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        var token;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getToken(force)];
                case 1:
                    token = _a.sent();
                    return [2 /*return*/, (token === null || token === void 0 ? void 0 : token.tokenType) + " " + (token === null || token === void 0 ? void 0 : token.accessToken)];
            }
        });
    });
};
exports.getAuthorizationHeader = getAuthorizationHeader;
var logout = function () {
    localStorage_1.removeLocalStorage("tokens");
    window.location.href = exports.cesAuthOptions.authBaseURL + "/user/logout";
    document.getElementsByTagName("body")[0].style.display = "none";
};
exports.logout = logout;
var refreshToken = function (isDisableRedirect) {
    if (isDisableRedirect === void 0) { isDisableRedirect = false; }
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getToken(true, isDisableRedirect)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
};
exports.refreshToken = refreshToken;
var hello = function (name) {
    return "hello " + name;
};
exports.hello = hello;
var isLoginAs = function () {
    return !!exports.cesAuthOptions.isLoginAs;
};
exports.isLoginAs = isLoginAs;
var isLegacy = function () {
    return !!exports.cesAuthOptions.isLegacy;
};
exports.isLegacy = isLegacy;
var isInit = function () {
    return !!exports.cesAuthOptions.isInit;
};
exports.isInit = isInit;
var cesAuth = {
    logout: exports.logout,
    refreshToken: exports.refreshToken,
    getAuthorizationHeader: exports.getAuthorizationHeader,
    redirectToLogin: exports.redirectToLogin,
    isAuthenticated: exports.isAuthenticated,
    isLoginAs: exports.isLoginAs,
    isLegacy: exports.isLegacy,
    isInit: exports.isInit,
    initCesAuth: exports.initCesAuth,
    startGetTokenLoop: exports.startGetTokenLoop,
    stopGetTokenLoop: exports.stopGetTokenLoop
};
if (typeof window !== "undefined") {
    window.cesAuth = cesAuth;
}
